/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementEmailConfDto } from '../../models/agreement-email-conf-dto';
import { AgreementItem } from '../../models/agreement-item';
import { BaseResponse } from '../../models/base-response';

export interface AgreementsControllerAddDdtEmailConfiguration$Params {
  id: number;
      body: AgreementEmailConfDto
}

export function agreementsControllerAddDdtEmailConfiguration(http: HttpClient, rootUrl: string, params: AgreementsControllerAddDdtEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerAddDdtEmailConfiguration.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AgreementItem;
      }>;
    })
  );
}

agreementsControllerAddDdtEmailConfiguration.PATH = '/agreements/{id}/email-configuration/ddt';
